import Api from './Api';

export default {
  getBaseInfo: () => Api.get('/v1/user/baseInfo'),
  login: async (login, password) => {
    try {
      const result = await Api.post('/v1/user/auth/login', { login, password });
      const { csrfToken } = result.data;
      localStorage.csrfToken = csrfToken;
      return true;
    } catch (e) {
      throw e;
    }
  },
  refreshAuth: async () => {
    try {
      const result = await Api.post('/v1/user/auth/refresh');
      const { csrfToken } = result.data;
      localStorage.csrfToken = csrfToken;
      return true;
    } catch (e) {
      throw e;
    }
  },
  logout: async () => {
    await Api.post('/v1/user/auth/logout');
    localStorage.csrfToken = null;
  },
  sendRestoreMessage: email => Api.post('/v1/user/auth/sendRestoreKey', { email }),
  setPassword: params => Api.post('/v1/user/auth/setPassword', params),
  changePassword: params => Api.post('/v1/user/account/password', params),
  saveParams: params => Api.post('/v1/user/account', params),
};
